// src/components/offers/ServiceTierCard.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@dopomogai/ui';

// UPDATED: The props interface now expects final, translated strings.
interface ServiceTierCardProps {
  title: string;
  description: string;
  idealFor: string;
  ctaText: string;
  
  // onAction and index are still needed for interactivity and animation.
  onAction: (actionType: string, payload?: any) => void;
  index: number;
  // Optional explicit action for CTA. Falls back to default if not provided.
  action?: { type: string; payload?: any };
}

export const ServiceTierCard: React.FC<ServiceTierCardProps> = ({ 
  title, 
  description, 
  idealFor, 
  ctaText, 
  onAction, 
  index,
  action,
}) => {
  // REMOVED: All logic for looking up keys in pageProps is gone.
  // The component is now much simpler.

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.5, delay: index * 0.1, ease: 'easeOut' } 
    },
  };

  return (
    <motion.div
      variants={cardVariants}
      className="bg-white p-8 rounded-xl border-2 border-black h-full flex flex-col"
    >
      <div className="flex-grow">
        {/* The component now uses the direct string props. */}
        <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
        <p className="text-slate-600 mb-4">{description}</p>
        <p className="text-sm font-semibold text-slate-800 bg-slate-100 p-3 rounded-lg border-2 border-black">
          <span className="font-bold">Ideal For:</span> {idealFor}
        </p>
      </div>
      <div className="mt-8">
        <Button 
          text={ctaText} 
          variant="primary" 
          fullWidth
          // The action handler remains, using the final translated title for context.
          onClick={() => {
            if (action) {
              onAction(action.type, action.payload);
            } else {
              onAction('NAVIGATE_TO_PAGE', { path: `/contact?subject=${title}` });
            }
          }}
        />
      </div>
    </motion.div>
  );
};